import { ApiResourceMethod } from '@/api/api-requests-factory';
import { FileDataResponse } from '@/models/file-data-response.model';
import { TransactionDateFilterKeyList } from '@/models/transaction/transaction-list-filter.model';
import { TransactionListRequestModel } from '@/models/transaction/transaction-list.model';
import { clearObj, formatDatesInPayload } from '@marfa/bo-utils';

export default class GetTransactionsReportRequest extends ApiResourceMethod<FileDataResponse> {
  public perform(wlSLug: string, params: TransactionListRequestModel) {
    const requestData = { ...params };

    if (requestData.filterList && Object.keys(requestData.filterList).length > 0) {
      requestData.filterList = formatDatesInPayload({
        payload: { ...requestData.filterList },
      }, [
        TransactionDateFilterKeyList.CREATED_AT_FROM,
        TransactionDateFilterKeyList.CREATED_AT_TO,
        TransactionDateFilterKeyList.UPDATED_AT_FROM,
        TransactionDateFilterKeyList.UPDATED_AT_TO,
      ]);
    }

    return this.performer.requestWithMapper(
      {
        params: clearObj(requestData),
        url: `${wlSLug}/payment/csv`,
      },
    );
  }
}
